import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[imageload]'
})
export class ImageloadDirective {

  constructor(private elRef: ElementRef, private renderer: Renderer2,) { }
  ngAfterViewInit() {
    this.imageLoaded;
  }

  private backgroundUrls = {
    lazy: 'assets/images/contact-bg_776X1380.webp',
    lazy1: 'assets/images/recipes-bg_870X1920.webp',
  };
  imageLoaded = false;
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {

    if (!this.imageLoaded) {
      for (const [className, url] of Object.entries(this.backgroundUrls)) {
        const dom : any = document.querySelector(`.${className}`)
        if (dom) {
          this.renderer.setStyle(dom, 'backgroundImage', `url(${url})`);
        }
        this.imageLoaded = true;
      }
    }
  }
}

